import React from 'react';
import DatePicker from 'react-datepicker';

interface FormFieldProps {
  label: string;
  name: string;
  type?: React.HTMLInputTypeAttribute;
  value?: string;
  placeholder?: string;
  required?: boolean;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
}
export const FormField: React.FC<FormFieldProps> = ({
  label,
  name,
  type = 'text',
  value,
  placeholder,
  required = false,
  onChange,
}) => {
  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '8px',
    border: '1px solid #333',
    backgroundColor: '#2a2a2a',
    color: '#fff',
    fontSize: '0.8rem',
    outline: 'none',
    boxSizing: 'border-box',
    marginTop: '6px',
  };

  return (
    <div style={{marginBottom: '20px'}}>
      <label
        htmlFor={name}
        style={{
          display: 'block',
          color: '#aaa',
          fontSize: '0.75rem',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}>
        {label} {required && <span style={{color: '#daff00'}}>*</span>}
      </label>

      {type === 'textarea' ? (
        <textarea
          id={name}
          name={name}
          required={required}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          rows={4}
          style={{...inputStyle, resize: 'vertical'}}
        />
      ) : (
        <input
          id={name}
          name={name}
          type={type}
          required={required}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={inputStyle}
        />
      )}
    </div>
  );
};
